import { useForm } from 'react-hook-form';
import { Form, TextFieldControl, useToast } from '@myhrbox/myhrbox-frontend-core';
import { Button, Stack } from '@mui/material';
import { useLoginByLoginMutation } from '@generated/graphql';
import useHandleLogin from 'pages/onboarding/Login/useHandleLogin';

interface ILoginFormData {
  login: string;
  password: string;
}

const LoginForm = () => {
  const { showErrorToast } = useToast();
  const form = useForm<ILoginFormData>();
  const { handleSubmit, setError } = form;
  const [login, { loading }] = useLoginByLoginMutation();
  const handleLogin = useHandleLogin();

  const onSubmit = (formData: ILoginFormData) => {
    login({
      variables: {
        login: formData.login,
        password: formData.password,
      },
    })
      .then((res) => {
        const accessToken = res.data?.loginByLogin.accessToken;
        const refreshToken = res.data?.loginByLogin.refreshToken;

        handleLogin(accessToken, refreshToken);
      })
      .catch(() => {
        setError('login', { message: 'Invalid login or password' });
        setError('password', { message: 'Invalid login or password' });
        showErrorToast('Invalid login or password');
      });
  };

  return (
    <Form form={form}>
      <Stack spacing={3}>
        <TextFieldControl label='Login' name='login' rules={{ required: true }} />
        <TextFieldControl
          label='Password'
          name='password'
          rules={{ required: true }}
          type='password'
        />
        <Button variant='contained' size='large' loading={loading} onClick={handleSubmit(onSubmit)}>
          Login
        </Button>
      </Stack>
    </Form>
  );
};

export default LoginForm;
